module.exports = __webpack_public_path__ + "img/twitter-d.8b423d11.svg";